/**
 * AWS Amplify Configuration
 * Configures Amplify to connect with Cognito User Pool
 * Requirements: 6.1, 12.1, 12.2
 */
import { Amplify } from 'aws-amplify';
import type { ResourcesConfig } from 'aws-amplify';

// Environment variables for Cognito configuration
const cognitoConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
      loginWith: {
        username: true,
      },
      signUpVerificationMethod: 'code',
      userAttributes: {
        email: {
          required: true,
        },
      },
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
      },
    },
  },
};

/**
 * Initialize AWS Amplify with Cognito configuration
 * Call this function in the application entry point (main.tsx)
 */
export const configureAmplify = (): void => {
  Amplify.configure(cognitoConfig);
};

export { cognitoConfig };
